import { io } from 'socket.io-client';

export const socketInit = () => {
  const options = {
    forceNew: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 1000,
    reconnectionAttempts: Infinity,
    timeout: 10000,
    transports: ['websocket'],
  };

  // So emits hit the same server as the API: local → local backend, else same origin (app.notiz.se)
  const isLocal = typeof window !== 'undefined' && window.location?.hostname === 'localhost';
  const origin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'https://app.notiz.se';
  const socketUrl = isLocal ? 'http://localhost:5001' : (process.env.REACT_APP_URL_SOCKET || origin);
  const socket = io(socketUrl, options);
  // Ask for screen status (online/offline, screenshots). The server only sends those to CMS tabs.
  socket.on('connect', () => socket.emit('cms:watch'));
  return socket;
};